import React from "react";

import { GenericExternalLink } from "@components/generic-external-link";
import {
  getNorthbeamUtmPlatformParams,
  NorthbeamUtmPlatform,
} from "@features/utm-guide";

export function ImpactRadius() {
  const urlParamPairs = getNorthbeamUtmPlatformParams({
    platform: NorthbeamUtmPlatform.IMPACT_RADIUS,
  });
  return (
    <div className="flex flex-col gap-3">
      <p className="mb-0">
        For each of the following parameter pairs, input them into{" "}
        <b>Partner Tracking Template</b> page.
      </p>
      <p className="mb-0">
        For more instructions, please consult the official{" "}
        <GenericExternalLink href="https://impact-helpdesk.freshdesk.com/en/support/solutions/articles/155000000002-gateway-tracking-templates#program-tracking-template-0-0">
          documentation
        </GenericExternalLink>
        .
      </p>
      <table className="table table-bordered table-striped table-sm bg-white">
        <thead>
          <tr>
            <th>Key</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          {urlParamPairs.map(({ key, value }) => (
            <tr key={key}>
              <td>{key}</td>
              <td>{value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
